import { render, staticRenderFns } from "./FreeSignupPinsReport.vue?vue&type=template&id=84035c1e"
import script from "./FreeSignupPinsReport.vue?vue&type=script&lang=js"
export * from "./FreeSignupPinsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports